/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_VacuumsInputs */

const he_home_category_vacuums = /** @type {(inputs: Home_Category_VacuumsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שואבי אבק`)
};

const en_home_category_vacuums = /** @type {(inputs: Home_Category_VacuumsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacuums`)
};

/**
* | output |
* | --- |
* | "Vacuums" |
*
* @param {Home_Category_VacuumsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_vacuums = /** @type {((inputs?: Home_Category_VacuumsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_VacuumsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_vacuums(inputs)
	return en_home_category_vacuums(inputs)
});